import { useEffect, useState } from 'react';
import Autocomplete from 'react-google-autocomplete';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { Spinner } from '../spinner/spinner';
import { FieldLabel } from './field';

export const PlacesAutocomplete = ({
  className,
  label,
  inputValue,
  onChange,
  onPlaceSelected,
  isRequired = false,
  placeholder,
  dataCy,
}: {
  className?: string;
  label?: string;
  inputValue: any;
  onChange: (newValue: any) => any;
  onPlaceSelected: (newValue: any) => any;
  isRequired?: boolean;
  placeholder?: string;
  dataCy?: string;
}) => {
  const { getConfiguration } = useAPI();
  const [googleApiKeyValue, setGoogleApiKey] = useState<string>(),
    [isContentLoading, setContentLoader] = useState<boolean>(true);

  useEffect(() => {
    const getSettings = async () => {
      setContentLoader(true);

      const googleConfiguration = await getConfiguration('CONF_MAP_GOOGLEAPI_KEY');

      setGoogleApiKey(googleConfiguration ? googleConfiguration.value : '');
      setContentLoader(false);
    };

    getSettings();
  }, []);

  return (
    <div className={`${className}`}>
      <FieldLabel label={label} isRequired={isRequired} />

      {isContentLoading ? (
        <Spinner />
      ) : (
        <Autocomplete
          apiKey={googleApiKeyValue}
          options={{
            types: ['address'],
          }}
          onChange={(element) => {
            onChange(element.currentTarget.value);
          }}
          onPlaceSelected={(place) => {
            if (!place?.place_id) return;

            const address = {
              address1: place.formatted_address,
              postcode: '',
              city: '',
              state: '',
              country: '',
            };

            for (const component of place.address_components) {
              const componentType = component.types.filter((type: string) => type != 'political')[0];

              switch (componentType) {
                case 'street_number': {
                  //address.address1 = `${component.long_name} ${address.address1}`;
                  break;
                }

                case 'route': {
                  //address.address1 += component.short_name;
                  break;
                }

                case 'postal_code': {
                  address.postcode = `${component.long_name}${address.postcode}`;
                  break;
                }

                case 'postal_code_suffix': {
                  address.postcode = `${address.postcode}-${component.long_name}`;
                  break;
                }
                case 'locality':
                  address.city = component.long_name;
                  break;

                case 'administrative_area_level_1': {
                  address.state = component.long_name;
                  break;
                }
                case 'country':
                  address.country = component.long_name;
                  break;
              }
            }

            onPlaceSelected(address);
          }}
          style={{ width: '100%' }}
          className="m-0 box-border h-10 w-full rounded border border-solid border-gray-300 bg-white pl-1 pr-1 font-sans text-gray-700 shadow-sm"
          data-cy={dataCy}
          defaultValue={inputValue}
          aria-placeholder={placeholder}
        />
      )}
    </div>
  );
};
